import { getBookmarksForItems } from '../user/bookmark'
import { isSearchResultMatchesEqual } from '../../utils/item'
import { logSearchResult } from '../../utils/eventsApi'
import { trackSearchResultsDisplay } from '../../utils/tracking/trackSearchResultsDisplay'

const onSearchPageDidUpdate = (location, prevUser, prevResults) => {
  return (dispatch, getState) => {
    const state = getState()
    const { results, timeout } = state.searchPage
    const { currentSite } = state.common
    const { user } = state

    // Log to events api only when:
    // - user data will be loaded on search results page for the first time (initial search page render)
    // - successful search will be done after initial render
    // - timeout will happen (we need to log timeouts also)
    const newUserLoadAttempt = !prevUser.hasLoadAttempt && user.hasLoadAttempt
    const isNewSearch = !isSearchResultMatchesEqual(
      results.matches,
      prevResults.matches
    )
    const isTimeout = user.hasLoadAttempt && timeout
    if (newUserLoadAttempt || isNewSearch || isTimeout) {
      logSearchResult(results, location, currentSite, user, timeout)
      trackSearchResultsDisplay(currentSite, location)
    }
    if (newUserLoadAttempt || isNewSearch) {
      dispatch(getBookmarksForItems(results.matches.map(match => match.id)))
    }
  }
}

export default onSearchPageDidUpdate



// WEBPACK FOOTER //
// ./common/actions/search/onSearchPageDidUpdate.js